import React from "react";

import image1 from "../assets/KPO_baner.jpg";
import { Box, Grid, Paper } from "@material-ui/core";
import styled from "styled-components";
import { useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  box: {
    [theme.breakpoints.down("xs")]: {
      height: "",
    },
    [theme.breakpoints.between("sm", "md")]: {
      height: "",
    },
    "@media (min-width: 900px)": {
      height: "100vh",
    },
  },
  topGrid: {
    [theme.breakpoints.up("xl")]: {
      height: theme.typography.body1.fontSize === "1rem" && "25%",
    },
    [theme.breakpoints.up("lg")]: {
      height: theme.typography.body1.fontSize === "1rem" && "15%",
    },
  },
  centerGrid: {
    [theme.breakpoints.up("xl")]: {
      height: theme.typography.body1.fontSize === "1rem" && "55%",
    },
    [theme.breakpoints.up("lg")]: {
      height: theme.typography.body1.fontSize === "1rem" && "70%",
    },
  },
  bottomGrid: {
    [theme.breakpoints.up("xl")]: {
      height: theme.typography.body1.fontSize === "1rem" && "10%",
    },
    [theme.breakpoints.up("lg")]: {
      height: theme.typography.body1.fontSize === "1rem" && "10%",
    },
    color: theme.palette.text.primary,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.primary,
  },
  text: {
    color: theme.palette.text.primary,
    fontWeight: "normal",
    paddingBottom: "10px",
    marginRight: "30px",
    marginLeft: "30px",
    fontSize: "1.00em",
    lineHeight: "1.6em",
    fontFamily: "sans-serif",
    [theme.breakpoints.down("xl")]: {
      marginRight: "20px",
      marginLeft: "20px",
      fontSize: "1em",
      lineHeight:
        theme.typography.body1.fontSize === "1rem" ? "1.6em" : "1.5em",
    },
    [theme.breakpoints.down("lg")]: {
      marginRight: "20px",
      marginLeft: "20px",
      fontSize:
        theme.typography.body1.fontSize === "1rem"
          ? "1.0em"
          : theme.typography.body1.fontSize === "1.17rem"
          ? "1.03em"
          : "0.875em",
      lineHeight:
        theme.typography.body1.fontSize === "1rem" ? "1.6em" : "1.3em",
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: "20px",
      marginLeft: "20px",
      fontSize:
        theme.typography.body1.fontSize === "1rem" ? "1.0em" : "0.875em",
      lineHeight:
        theme.typography.body1.fontSize === "1rem" ? "1.6em" : "1.3em",
    },
    [theme.breakpoints.down("xs")]: {
      marginRight: "10px",
      marginLeft: "10px",
      fontSize: "0.775em",
      lineHeight: "1.0em",
    },
  },
  text2: {
    textAlign: "center",
    marginLeft: "10px",
    marginRight: "10px",
    paddingTop: "3px",
    color: theme.palette.primary.main === "#fff200" ? "yellow" : "#122127",
    fontSize: "0.8em",
    [theme.breakpoints.down("xs")]: {
      marginRight: "3px",
      marginLeft: "3px",
      fontSize: "0.775em",
      lineHeight: "1.0em",
    },
  },
}));

const FeatureBox = styled(({ image, number, text, subtext }) => (
  <Box display="block" color="#fff" textAlign="center" m={3}>
    <img src={image} alt="" />

    <Box fontWeight="bold">
      <Box display="inline" as="span" color="orange">
        {number}.&nbsp;
      </Box>
      {text}
    </Box>
    <Box fontSize={10}>{subtext}</Box>
  </Box>
))`
  width: 300px;
  height: 300px;
`;

const LeftComponentMui = () => {
  const classes = useStyles();
  const globalTheme = useSelector((s) => s.globalTheme);
  const baseFontSize = useSelector((s) => s.baseFontSize);
  return (
    <Grid
      item
      sm={12}
      xs={12}
      md={8}
      container
      direction="row"
      justifyContent="space-between"
      style={{
        color: globalTheme === "high-contrast" ? "black" : "white",
        backgroundColor: globalTheme === "high-contrast" ? "black" : "white",
      }}
    >
      <Grid item xs={12} className={classes.topGrid}>
        <Box display="flex" justifyContent="center">
          <img src={image1} alt="" />
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        className={`${classes.bottomGrid} ${classes.text2} `}
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <p>
        </p>
      </Grid>
    </Grid>
  );
};

export default LeftComponentMui;
